var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, computed, onBeforeUnmount } from 'vue';
import PerfectScrollbar from 'perfect-scrollbar';
import { addResizeListener, removeResizeListener } from '@common/utils/ResizeEvent';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EScrollbar',
    props: {
        options: {}
    },
    emits: ["scroll", "ps-scroll-y", "ps-scroll-x", "ps-scroll-up", "ps-scroll-down", "ps-scroll-left", "ps-scroll-right", "ps-y-reach-start", "ps-y-reach-end", "ps-x-reach-start", "ps-x-reach-end"],
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var eventNames = [
            'scroll',
            'ps-scroll-y',
            'ps-scroll-x',
            'ps-scroll-up',
            'ps-scroll-down',
            'ps-scroll-left',
            'ps-scroll-right',
            'ps-y-reach-start',
            'ps-y-reach-end',
            'ps-x-reach-start',
            'ps-x-reach-end'
        ];
        var rootRef = ref(null);
        var perfectScrollbar = ref();
        var latestWidth = ref(0);
        var latestHeight = ref(0);
        onMounted(function () {
            initPerfectScrollbar();
            addResizeListener(rootRef.value, onResize);
        });
        onBeforeUnmount(function () {
            destroyPerfectScrollbar();
            removeResizeListener(rootRef.value, onResize);
        });
        var computedOptions = computed(function () {
            return __assign({ minScrollbarLength: 20 }, props.options);
        });
        var initPerfectScrollbar = function () {
            var e_1, _a;
            if (!perfectScrollbar.value && rootRef.value) {
                perfectScrollbar.value = new PerfectScrollbar(rootRef.value, computedOptions.value);
                var _loop_1 = function (eventName) {
                    perfectScrollbar.value.element.addEventListener(eventName, function (event) { return emit(eventName, event); });
                };
                try {
                    for (var eventNames_1 = __values(eventNames), eventNames_1_1 = eventNames_1.next(); !eventNames_1_1.done; eventNames_1_1 = eventNames_1.next()) {
                        var eventName = eventNames_1_1.value;
                        _loop_1(eventName);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (eventNames_1_1 && !eventNames_1_1.done && (_a = eventNames_1.return)) _a.call(eventNames_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        };
        var destroyPerfectScrollbar = function () {
            setTimeout(function () {
                var _a;
                (_a = perfectScrollbar.value) === null || _a === void 0 ? void 0 : _a.destroy();
                perfectScrollbar.value = undefined;
            }, 1000);
        };
        var onResize = function (e) {
            var _a;
            if (
            // При скрытии родительских блоков значения будут равняться 0, не нужно реагировать в этом случае
            !(e.contentRect.width === 0 && e.contentRect.height === 0)
                && (latestWidth.value !== e.contentRect.width
                    || latestHeight.value !== e.contentRect.height)) {
                latestWidth.value = e.contentRect.width;
                latestHeight.value = e.contentRect.height;
                (_a = perfectScrollbar.value) === null || _a === void 0 ? void 0 : _a.update();
            }
        };
        var scrollToBottom = function () {
            rootRef.value.scrollTop = rootRef.value.scrollHeight;
        };
        var scrollToTop = function () {
            rootRef.value.scrollTop = 0;
        };
        __expose({
            scrollToTop: scrollToTop,
            scrollToBottom: scrollToBottom,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
                ref_key: "rootRef",
                ref: rootRef,
                class: "e-scrollbar"
            }), [
                _renderSlot(_ctx.$slots, "default")
            ], 16));
        };
    }
});
